// import React from "react";
// import { Link } from "react-router-dom";

// const C = {
//   forest: "#16261F",
//   forest2: "#1F3529",
//   brick: "#A8452F",
//   moss: "#4B6B4F",
//   river: "#2E6E6A",
//   sand: "#EFE8D6",
//   sandDeep: "#E4DBC3",
//   gold: "#C79A3E",
//   ink: "#1E241F",
//   cream: "#F5F0E3",
//   creamDim: "#CFCBBB",
//   white:"#ffffff"
// };



// export default function Footer() {
//   return (
//     <footer className="bg-success text-light pt-4 mt-5">
//       <div className="container">
//         <div className="row">

//           {/* ABOUT */}
//           <div className="col-md-4 mb-3">
//             <h5>NIVARA AGRO TOURISM</h5>
//             <p className="small">
//               Comfortable stays, Honest Prices, A River Worth the Drive.
//             </p>
//           </div>



//          {/* QUICK LINKS */}

//          <div className="col-md-4 mb-3">
//           <div className="col-lg-2 col-md-4">
//             <h5
//               className="fw-bold mb-3"
//               style={{
//                 color: C.white,
//                 letterSpacing: "0.04em",
//               }}
//             >
//               Quick Links
//             </h5>
              
//             <div className="d-flex flex-column gap-2">

//               <Link
//                 to="/"
//                 className="footer-link"
//               >
//                 Home
//               </Link>
              
//               <Link
//                 to="/about"
//                 className="footer-link"
//               > 
//                 About Us
//               </Link>
             

//               <Link
//                 to="/activities"
//                 className="footer-link"
//               >
//                 Activities
//               </Link>

//               <Link
//                 to="/services"
//                 className="footer-link"
//               >
//                 Services
//               </Link>

//               <Link
//                 to="/contact"
//                 className="footer-link"
//               >
//                 Contact
//               </Link>

//             </div>
//           </div>
//               </div>

//           {/* CONTACT */}
//           <div className="col-md-4 mb-3">
//             <h5>Contact Us</h5>
//             <p>📍 Tapola, Maharashtra</p>
//             <p>📞 +91 82756 07686</p>
//             <p>📧 nivaraagrotourism@gmail.com</p>
            
//           </div>

//           {/* SOCIAL */}
//           <div className="col-md-4 mb-3">
//             <h5>Follow Us</h5>
//             <a href="#" className="text-light me-3"><i className="bi bi-facebook text-primary me-1"></i></a>

            
//             <a href="#" className="text-light me-3"><i className="bi bi-instagram text-danger me-1"></i></a>
//             <a href="#" className="text-light"><i className="bi bi-youtube text-danger me-1"></i></a>
         
//           <div>
//             <p></p>
//           <p style={{ fontFamily: "'Space Mono', monospace", color: C.white, fontSize: 14, letterSpacing: "0.1em" }}>BOOK DIRECT</p>
//           <p className="mt-2" style={{ fontFamily: "Archivo, sans-serif", color: C.white, fontSize: 14, lineHeight: 1 }}>
//             No booking-site markup 
//             Call or Message us directly for the best rate.
//           </p>
//           <button
//           Link to="/rooms"
//             className="mt-3 px-6 py-2.5 rounded-full text-sm"
//             style={{ background: C.brick, color: C.white, fontFamily: "Archivo, sans-serif" }}
//           >
//             Book a Stay
          
//           </button>
           
//         </div>
         
     
         
//           </div>

//         </div>

//         <div className="text-center border-top pt-3 mt-3">
//           <small>© {new Date().getFullYear()} Nivara Agro Tourism. All rights reserved.</small>
//         </div>
//       </div>
//     </footer>
//   );
// }



import React from "react";
import { Link } from "react-router-dom";

const C = {
  forest: "#16261F",
  forest2: "#1F3529",
  brick: "#A8452F",
  moss: "#4B6B4F",
  river: "#2E6E6A",
  sand: "#EFE8D6",
  sandDeep: "#E4DBC3",
  gold: "#C79A3E",
  ink: "#1E241F",
  cream: "#F5F0E3",
  creamDim: "#CFCBBB",
  white: "#ffffff",
};

const socials = [
  { name: "Facebook", icon: "bi-facebook", href: "#", color: "#3b5998" },
  { name: "Instagram", icon: "bi-instagram", href: "#", color: "#d6249f" },
  { name: "YouTube", icon: "bi-youtube", href: "#", color: "#ff0000" },
];

export default function Footer() {
  return (
    <footer className="bg-success text-light pt-4 mt-5">
      <style>{`
        .footer-link {
          color: ${C.creamDim};
          text-decoration: none;
          transition: color 0.2s ease;
        }
        .footer-link:hover {
          color: ${C.gold};
        }
        .social-icon-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          text-decoration: none;
          width: 70px;
        }
        .social-icon-circle {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255,255,255,0.08);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: ${C.white};
          transition: transform 0.25s ease, background 0.25s ease;
        }
        .social-icon-wrap:hover .social-icon-circle {
          transform: scale(1.25);
        }
        .social-icon-label {
          font-size: 12px;
          color: ${C.creamDim};
          font-family: Archivo, sans-serif;
        }
        .book-direct-btn {
          background: ${C.brick};
          color: ${C.white};
          font-family: Archivo, sans-serif;
          border: none;
          padding: 10px 24px;
          border-radius: 999px;
          font-size: 14px;
          display: inline-block;
          text-decoration: none;
          transition: background 0.2s ease;
        }
        .book-direct-btn:hover {
          background: #8f3a27;
          color: ${C.white};
        }
      `}</style>

      <div className="container">
        <div className="row">
          {/* ABOUT */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3" style={{ color: C.white, letterSpacing: "0.04em" }}>
              NIVARA AGRO TOURISM
            </h5>
            <p className="small" style={{ color: C.creamDim }}>
              Comfortable stays, Honest Prices, A River Worth the Drive.
            </p>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3" style={{ color: C.white, letterSpacing: "0.04em" }}>
              Quick Links
            </h5>
            <div className="d-flex flex-column gap-2">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/activity" className="footer-link">Activities</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>
          </div>

          {/* CONTACT */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3" style={{ color: C.white, letterSpacing: "0.04em" }}>
              Contact Us
            </h5>
            <p style={{ color: C.creamDim }}>📍 Tapola, Maharashtra</p>
            <p style={{ color: C.creamDim }}>📞 +91 82756 07686</p>
            <p style={{ color: C.creamDim }}>📧 nivaraagrotourism@gmail.com</p>
          </div>

          {/* SOCIAL + BOOK DIRECT */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3" style={{ color: C.white, letterSpacing: "0.04em" }}>
              Follow Us
            </h5>

            <div className="d-flex gap-3 mb-4">
              {socials.map((s) => (
                <a key={s.name} href={s.href} className="social-icon-wrap">
                  <div className="social-icon-circle">
                    <i className={`bi ${s.icon}`}></i>
                  </div>
                  <span className="social-icon-label">{s.name}</span>
                </a>
              ))}
            </div>

            <p
              style={{
                fontFamily: "'Space Mono', monospace",
                color: C.white,
                fontSize: 14,
                letterSpacing: "0.1em",
                marginBottom: 4,
              }}
            >
              BOOK DIRECT
            </p>
            <p
              style={{
                fontFamily: "Archivo, sans-serif",
                color: C.creamDim,
                fontSize: 13,
                lineHeight: 1.4,
                marginBottom: 12,
              }}
            >
              No booking-site markup. Call or message us directly for the best rate.
            </p>

            <Link to="/rooms" className="book-direct-btn">
              Book a Stay
            </Link>
          </div>
        </div>

        <div className="text-center border-top pt-3 mt-3" style={{ borderColor: "rgba(255,255,255,0.15)" }}>
          <small style={{ color: C.creamDim }}>
            © {new Date().getFullYear()} Nivara Agro Tourism. All rights reserved.
          </small>
        </div>
      </div>
    </footer>
  );
}